/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetContactsMutationRequest,
  PerformSetContactsMutationResponse,
  PerformSetContactsPathParams,
  PerformSetContacts400,
  PerformSetContacts404,
} from '../types/PerformSetContacts'

function getPerformSetContactsUrl({
  import_number,
}: {
  import_number: PerformSetContactsPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-contacts/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-contacts step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-contacts/}
 */
export async function performSetContacts(
  {
    import_number,
  }: { import_number: PerformSetContactsPathParams['import_number'] },
  data?: PerformSetContactsMutationRequest,
  config: Partial<RequestConfig<PerformSetContactsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    PerformSetContactsMutationResponse,
    ResponseErrorConfig<PerformSetContacts400 | PerformSetContacts404>,
    PerformSetContactsMutationRequest
  >({
    method: 'POST',
    url: getPerformSetContactsUrl({ import_number }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
